import { createContext } from 'react';

export const CampaignsContext = createContext();